/**
 * @generated SignedSource<<8e900ffd34834bc23b51a70d0e7a357f>>
 * @relayHash 5058697198d8a07cbcd16dbed48a1713
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 40e97fb409bce2f7bc7073de0f1dd1e926440b0f988f637a1fd56d39b2ee4578

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraFieldOptionIdsFilterOperation = "ALLOW" | "EXCLUDE" | "%future added value";
export type JiraFieldOptionIdsFilterInput = {
  operation: JiraFieldOptionIdsFilterOperation;
  optionIds: ReadonlyArray<string>;
};
export type singleSelect_SingleSelect_suggestionsQuery$variables = {
  filterById?: JiraFieldOptionIdsFilterInput | null | undefined;
  id: string;
};
export type singleSelect_SingleSelect_suggestionsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"singleSelect_issueFieldSingleSelectEditviewFull_SingleSelectEditViewWithFieldOptionsFragment">;
};
export type singleSelect_SingleSelect_suggestionsQuery = {
  response: singleSelect_SingleSelect_suggestionsQuery$data;
  variables: singleSelect_SingleSelect_suggestionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterById"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "kind": "Variable",
  "name": "filterById",
  "variableName": "filterById"
},
v3 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "id"
},
v4 = {
  "kind": "Literal",
  "name": "searchBy",
  "value": ""
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = [
  (v2/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  },
  (v4/*: any*/)
],
v7 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "singleSelect_SingleSelect_suggestionsQuery",
    "selections": [
      {
        "args": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "singleSelect_issueFieldSingleSelectEditviewFull_SingleSelectEditViewWithFieldOptionsFragment"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "singleSelect_SingleSelect_suggestionsQuery",
    "selections": [
      {
        "args": [
          (v3/*: any*/)
        ],
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v6/*: any*/),
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "fieldOptions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": "value",
                            "kind": "ScalarField",
                            "name": "id"
                          },
                          {
                            "alias": "label",
                            "kind": "ScalarField",
                            "name": "value"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "optionId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isDisabled"
                          },
                          (v7/*: any*/),
                          (v5/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v6/*: any*/),
                "filters": [
                  "searchBy",
                  "filterById"
                ],
                "handle": "connection",
                "key": "main_issueFieldSingleSelectEditviewFull__fieldOptions",
                "kind": "LinkedHandle",
                "name": "fieldOptions"
              }
            ],
            "type": "JiraSingleSelectField"
          },
          (v7/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "40e97fb409bce2f7bc7073de0f1dd1e926440b0f988f637a1fd56d39b2ee4578",
    "metadata": {},
    "name": "singleSelect_SingleSelect_suggestionsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4e33b70da34aeea67c6630a98333d3b5";

export default node;
